import { css } from '@emotion/react';

const makeNavigationBarStyling = ({ theme, isSmartAdvance }) => {
  return {
    box: css({
      marginTop: theme.mvf.spacing.tiny,
      marginBottom: theme.mvf.spacing.medium,
      ...(isSmartAdvance && {
        marginBottom: theme.mvf.spacing.small,
      }),
      height: 45,
      [theme.breakpoints.up('tabletSmall')]: {
        height: 55,
      },
    }),
  };
};

export default makeNavigationBarStyling;
